// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import { store } from "./store/index";
//使用 this.$cookies.set("token","123456",60 * 60 * 24)
import VueCookies from "vue-cookies";
//弹框
import install from "./plugins/install";
import "./utils/filter"; // 全局 filter
import "./basecss/bacecss.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./theme/index.css";
import VideoPlayer from "vue-video-player";
import $ from "jquery";
window.$ = $; //原因：设置变量但未使用，编辑器会报错。
let gMixin = require('@/mixin/g.mixin.js');
Vue.mixin(gMixin);
Vue.use(VideoPlayer);
Vue.directive("image-error", {
  bind(el, binding) {
    el.addEventListener("error", () => {
      el.setAttribute("src", binding.value);
    });
  },
  update(el, binding) {
    el.addEventListener("error", () => {
      el.setAttribute("src", binding.value);
    });
  }
});
import "./assets/font/font_step/iconfont.css";
import { filters } from "./filters/index";

// if(process.env.NODE_ENV == 'production'){
//   console.log = function(){}
// }

// 定义全局自定义过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueCookies);
Vue.use(install);

router.afterEach(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js